import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { SABRE_SEGMENT_API_PATH } from "@/modules/SabreSegment/constants";

class sabreSegmentService {
  private restClient: RestClientService;
  constructor() {
    this.restClient = new RestClientService();
  }
  public getByDefaultSegmentStats(
    organizationId: string,
  ): Promise<ICoreResponse> {
    const organization = `${organizationId}/`;
    return this.restClient.post(
      `${SABRE_SEGMENT_API_PATH.POST_DEFAULT_STATS}${organization}`,
      "",
    );
  }
  public getByDefaultSegmentList(
    organizationId: string,
  ): Promise<ICoreResponse> {
    const organization = `${organizationId}/`;
    return this.restClient.post(
      `${SABRE_SEGMENT_API_PATH.POST_DEFAULT_LIST}${organization}`,
      "",
    );
  }
  public getCustomSegmenStats(
    start_date: string,
    end_date: string,
    organizationId?: string,
  ): Promise<ICoreResponse> {
    const organization = organizationId ? `${organizationId}/` : "";

    return this.restClient.post(
      `${SABRE_SEGMENT_API_PATH.POST_DEFAULT_STATS}${organization}?start_date=${start_date}&end_date=${end_date}`,
      "",
    );
  }
  public getCustomSegmenLists(
    start_date: string,
    end_date: string,
    organizationId?: string,
  ): Promise<ICoreResponse> {
    const organization = organizationId ? `${organizationId}/` : "";

    return this.restClient.post(
      `${SABRE_SEGMENT_API_PATH.POST_DEFAULT_LIST}${organization}?start_date=${start_date}&end_date=${end_date}`,
      "",
    );
  }
}
export default sabreSegmentService;
